export const SEARCH_TERMS = ["title"];
export const inputFields = {
  title: {
    type: "string",
    required: true,
    title: "Title",
    slug: true,
    inputType: "text",
  },
  description: {
    type: "html",
    required: false,
    title: "Description",
  },

  gallery: {
    type: "gallery",
    required: false,
    title: "Gallery",
  },
  goal: {
    type: "string",
    required: true,
    title: "Goal",
    inputType: "number",
  },
  achieved: {
    type: "string",
    required: true,
    title: "Achieved",
    inputType: "number",
  },

  slug: {
    type: "slug",
    required: true,
    targetField: "title",
    title: "Slug",
  },
};
export const initialValues = {
  title: "",
  goal: "",
  achieved: "",
  description: "",
  slug: "",
};

export const view_all_table = [
  { name: "Title", value: "title" },
  { name: "Goal", value: "goal" },
  { name: "Achieved", value: "achieved" },
  { name: "Slug", value: "slug" },
];
